import React from 'react';
import { ScreenshotAndPdfFrame, ScreenshotHeader, ScreenshotFooter, ScreenshotContent } from '../../../../components';
import { AppRouter } from '../';
import { defaultVariables } from '../../../../referenceData';
import {
	getSelectedSubjects,
	getSelectedSubjectName,
	getSelectedLocations,
	getUrlQueryParams,
} from '../../../../actions';
import { useAppContext } from '../../../../context/AppState.jsx';
import TitleWithNames from '../../../../components/NameTitle/index.jsx';

export default function ScreenshotFrame() {
	const [state] = useAppContext();
	if (!state.indexedYml) {
		return null;
	}

	const urlParams = getUrlQueryParams();
	const takingss = JSON.parse(urlParams?.takingss || false);

	if (!takingss) {
		return null;
	}
	const view = urlParams.view;
	let titleYear = false;
	switch (view) {
		case 'graph':
			// for graph, we only do this on the bar chart
			if (urlParams?.option === 'bar' && urlParams?.subview == 'absoluteTrend') {
				titleYear = `${JSON.parse(urlParams?.range1from) ?? defaultVariables.earliest_year}-${JSON.parse(urlParams?.range1to) ?? defaultVariables.latest_year}`;
			} else if (urlParams?.option === 'bar') {
				titleYear = JSON.parse(urlParams?.range1to) ?? defaultVariables.latest_year;
			}
			break;
		case 'map':
			if (urlParams.subview === 'score') {
				titleYear = JSON.parse(urlParams?.range1to) ?? defaultVariables.latest_year;
			} else {
				titleYear = defaultVariables.latest_year;
			}
			break;
		case 'overview':
			titleYear = defaultVariables.latest_year;
			break;
	}

	const title = (
		<TitleWithNames
			subjectNames={getSelectedSubjects(state).map((s) => getSelectedSubjectName(state, s))}
			locations={getSelectedLocations(state)}
			suffix={titleYear ? ` (${titleYear})` : ''}
		/>
	);

	return (
		<ScreenshotAndPdfFrame>
			<ScreenshotHeader />
			<ScreenshotContent title={title}>
				<AppRouter isTakingScreenshot={true} />
			</ScreenshotContent>
			<ScreenshotFooter currentYear={new Date().getFullYear()} />
		</ScreenshotAndPdfFrame>
	);
}
